import { Injectable } from '@angular/core';
import { ODataApiDataService } from 'app/core/storage/odata-api-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { MemberCorrespondenceType } from './member-correspondence-type.model';

const API_URL = environment.projectionQueryApi;
@Injectable({
  providedIn: 'root',
})
export class MemberCorrespondenceTypeQueryService {
  constructor(
    private dataService: ODataApiDataService<any>,
  ) { }

  getMemberCorrespondenceTypes(memberId: string): Observable<MemberCorrespondenceType[]> {

    return this.dataService
      .odataList(`${API_URL}/memberCorrespondenceTypes?$filter=MemberId eq ${memberId}&$orderby=EffectiveOn desc`)
      .pipe(
        map(res => {
          return res.map(item => {
            return this.parseCorrespondenceTypeObject(item);
          });
        }),
      );
  }

  parseCorrespondenceTypeObject(item: any): MemberCorrespondenceType {
    return {
      id: item.Id,
      typeOfPlace: `${item.CorrespondenceContactType[0].toLowerCase()}${item.CorrespondenceContactType.slice(1)}`,
      effectiveOn: new Date(item.EffectiveOn),
      endingOn: !!item.EndOn ? new Date(item.EndOn) : null,
      isCurrent: item.IsCurrent,
    } as MemberCorrespondenceType;
  }
}
